import { HashRouter, useRoutes } from "react-router-dom";
import "./App.css";
import { PrivateAuth } from "./Routes/PrivateRoutes";
import { PublicRoutes } from "./Routes/PublicRoutes";
import { SnackbarProvider } from "./Context/SnackbarContext";
import { useEffect, useState } from "react";
import { getLocalStorageItem } from "./Utils/Index";
import UseSocket from "./Hooks/UseSocket";
import { getBrand } from "./ApiService/Apis/Items/Item";
import { BrandProvider } from "./Context/BrandContext";

function App() {
  const [Routing, setRouting] = useState([
    ...PublicRoutes(),
    ...PrivateAuth(),
  ]);

  const RouteConfig = () => useRoutes(Routing);

  const Role = getLocalStorageItem("userDetail")?.role;

  const { socket } = UseSocket(
    Role === "kitchen"
      ? "kitchen"
      : Role === "service"
      ? "service"
      : Role === "restaurant"
      ? "restaurant"
      : ""
  );

  const FetchBrandDetails = () => {
    getBrand(getLocalStorageItem("userDetail")?.restaurantId)
      .then((response) => {
        if (response.status && response.data) {
          console.log(response);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (getLocalStorageItem("access_token")) {
      FetchBrandDetails();

      let data = [...PrivateAuth()];

      if (getLocalStorageItem("role") !== "customer") {
        data[0].children = data[0]?.children.filter(
          (i) => i.name !== "customer" || i.name === "*"
        );
      } else {
        data[0].children = data[0]?.children.filter(
          (i) => i.name === "customer" || i.name === "*"
        );
      }

      setRouting([...PublicRoutes(), ...data]);
    } else {
      setRouting([...PublicRoutes(), ...PrivateAuth()]);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <SnackbarProvider>
      <BrandProvider>
        <div className="bg-dynmaicBg">
          <HashRouter>
            <RouteConfig />
          </HashRouter>
        </div>
      </BrandProvider>
    </SnackbarProvider>
  );
}

export default App;